//export const webUrl = 'http://test.api.b2s2c.com/oms'
export const webUrl = 'http://cbec.giip-eport.com/oms';
// export const webUrl = 'http://106.124.141.124:81/oms';
// export const webUrl = 'http://giip-eport.com/oms'
//export const webUrl = 'http://192.168.3.39:7001/oms'
//export const webUrl = 'http://192.168.3.8:7001/oms';